import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class ButtonSetting {
  @IsBoolean()
  @Expose()
  isDisable!: boolean;
  @IsBoolean()
  @Expose()
  isVisible!: boolean;
  @IsString()
  @Expose()
  message!: string;

  constructor() {
    this.isDisable = false;
    this.isVisible = true;
    this.message = "";
  }
}
